import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionMarker({ num, label, className = '' }) {
    return (_jsxs("span", { className: `
        inline-flex items-center gap-1.5
        border border-cyan-border bg-cyan-surface
        px-2 py-[3px]
        font-mono text-[9.5px] font-normal uppercase
        tracking-[0.15em] text-cyan-text-secondary
        ${className}
      `, children: [_jsx("span", { "aria-hidden": true, className: "block h-1 w-1 rounded-full bg-cyan-network" }), _jsx("span", { className: "font-medium text-cyan-text", children: num }), _jsx("span", { "aria-hidden": true, className: "block h-[9px] w-px bg-cyan-border" }), _jsx("span", { children: label })] }));
}
//# sourceMappingURL=SectionMarker.js.map